import React, { useEffect, useState } from "react";

const INTERVAL = 20 * 1000; // 20 seconds
const THRESHOLD = 60 * 60 * 1000; // 1 hour

function SleepDetector({ origin }: { origin: string }) {
  useEffect(() => {
    let myTimeout: number;

    const detectSleep = () => {
      const startTime = Date.now();
      // console.log('Heartbeat:', startTime);

      myTimeout = window.setTimeout(() => {
        const endTime = Date.now();
        const sleepTime = endTime - startTime - INTERVAL;

        if (sleepTime > THRESHOLD) {
          console.log("==== RSI SLEEP DETECTED ====");
          window.parent.postMessage(
            JSON.stringify({
              event: "memory-error",
            }),
            origin
          );
        } else {
          detectSleep();
        }
      }, INTERVAL);
    };

    detectSleep();

    return () => {
      clearTimeout(myTimeout);
    };
  }, [origin]);

  return null;
}

export default SleepDetector;
